import * as React from 'react';

const LogoSpotifyColorSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 72 72"
        id="logo-spotify-color_svg__eds-icon--logo-spotify-color_svg"
        {...props}
    >
        <rect
            id="logo-spotify-color_svg__eds-icon--logo-spotify-color_1"
            fill="#fff"
            x={10}
            y={18}
            width={53}
            height={36}
            rx={6.73}
            ry={6.73}
        />
        <path
            id="logo-spotify-color_svg__eds-icon--logo-spotify-color_1"
            fill="#1ed760"
            d="M57 32c-11.43-6.79-30.28-7.41-41.19-4.1a3.32 3.32 0 11-1.93-6.35c12.52-3.8 33.35-3.07 46.5 4.74A3.32 3.32 0 0157 32zm-.4 10a2.77 2.77 0 01-3.8.91c-9.53-5.86-24.06-7.55-35.33-4.13a2.76 2.76 0 11-1.61-5.29c12.88-3.91 28.89-2 39.83 4.71a2.76 2.76 0 01.91 3.8zm-4.34 9.65a2.21 2.21 0 01-3 .74C40.9 47.33 30.42 46.18 18.07 49a2.21 2.21 0 11-1-4.31c13.51-3.09 25.09-1.76 34.44 4a2.21 2.21 0 01.73 3zM36 .54A35.46 35.46 0 1071.46 36 35.46 35.46 0 0036 .54z"
        />
    </svg>
);

LogoSpotifyColorSvg.displayName = 'LogoSpotifyColorSvg';
export default LogoSpotifyColorSvg;
